import Card from 'components/Card';
import Button from 'components/common/buttons/Button';
import { DataForm, Input, InputSelect } from 'components/formik_inputs';
import { withFormik } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useHistory, useParams } from 'react-router';
import {
  getTerm,
  editTerm,
  createTerm,
  deleteTerm,
} from '../../services/academic';
import CourseOfferInput from 'components/formik_inputs/custom-inputs/CourseOfferInput';
import { toast } from 'react-toastify';
import { fetchAvaliableTermNumbers } from 'services/options_services';
import { nativeGet as get } from 'utils';
import { PermissionContext } from 'hoc/withPermission';
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation';

const TermForm = ({ ...props }) => {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();
  const edit = location.pathname.includes('edit');

  const [term, setTerm] = useState({});
  const [termNumberOptions, setTermNumberOptions] = useState([]);

  const initialValues = {
    course_offer: '',
    name: '',
    abbreviation: '',
    number: '',
  };

  useEffect(() => {
    if (id) {
      getTerm(id).then((term) => {
        if (term.course_offer) {
          getTermNumberOptions(term.course_offer.id, term.number);
        }

        setTerm({
          ...term,
          number: term.number ? { label: term.number, value: term.number } : {},
        });
      });
    }
  }, [id]);

  const getTermNumberOptions = useCallback(
    (courseOfferId, additionalValue = null) => {
      if (!courseOfferId) {
        setTermNumberOptions([]);

        return;
      }

      fetchAvaliableTermNumbers(courseOfferId).then((values) => {
        if (additionalValue) {
          // Caso para adicionar o valor já cadastrado.
          setTermNumberOptions(
            [
              ...values,
              { value: additionalValue, label: additionalValue },
            ].sort((a, b) => a.value - b.value)
          );
        } else {
          setTermNumberOptions(values);
        }
      });
    },
    [termNumberOptions, term]
  );

  const handleCourseOfferChange = useCallback(
    (option) => {
      if (option) {
        const { id: courseOfferId } = option;
        if (term?.course_offer?.id == courseOfferId && term.number) {
          getTermNumberOptions(courseOfferId, term.number?.value);

          return;
        }

        getTermNumberOptions(courseOfferId);
      } else {
        getTermNumberOptions(null);
      }
    },
    [term]
  );

  const save = async (values) => {
    const data = {
      ...values,
      course_offer: values.course_offer?.id || null,
      number: values.number?.value || null,
    };

    if (edit) {
      await editTerm(id, data);

      toast.success('Etapa editada com sucesso.');
    } else {
      const { id: newId } = await createTerm(data);

      toast.success('Etapa criada com sucesso.');
      history.push(`/etapas/${newId}/edit`);
    }
  };

  const handleDelete = useCallback(async () => {
    try {
      await deleteTerm(id);

      toast.success('Etapa excluída com sucesso.');
      history.push('/etapas');
    } catch (err) {
      const error = get(err, 'response.data.detail', '');
      toast.error(error || 'Ocorreu um erro ao remover a Etapa.');
    }
  }, [id]);

  return (
    <Card title="Cadastrar Etapa">
      <DataForm
        initialValues={edit ? term : initialValues}
        onSubmit={save}
        autoSetErrors
        enableReinitialize
      >
        {(formik) => (
          <>
            <CourseOfferInput onChange={handleCourseOfferChange} required />
            <Input
              name="name"
              label="Nome da etapa"
              placeholder="Nome da etapa"
              type="text"
              required
            />
            <Input
              name="abbreviation"
              type="text"
              placeholder="Sigla"
              label="Sigla"
              required
            />
            <InputSelect
              required
              name="number"
              label="Número da etapa"
              placeholder="Número da etapa"
              noOptionsMessage={() =>
                formik.values.course_offer
                  ? 'Nenhum etapa disponivel para essa oferta de curso'
                  : 'Selecione uma oferta de curso'
              }
              options={termNumberOptions}
            />
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '20px',
              }}
            >
              <Button onClick={() => history.push('/etapas')}>Voltar</Button>
              <div>
                <PermissionContext.Consumer>
                  {({ hasPermission }) =>
                    hasPermission('academico.delete_term') &&
                    edit && (
                      <ButtonWithConfirmation
                        action="danger"
                        confirmationText="Deseja excluir permanentemente essa Etapa ?"
                        onClick={handleDelete}
                      >
                        Excluir
                      </ButtonWithConfirmation>
                    )
                  }
                </PermissionContext.Consumer>
                <Button type="submit">Salvar</Button>
              </div>
            </div>
          </>
        )}
      </DataForm>
    </Card>
  );
};

export default withFormik({
  course_offer: '',
  name: '',
  abbreviation: '',
  number: '',
})(TermForm);
